import type { IconProps } from '../types/IconProps.ts';
export const Heart: IconProps = {
    name: 'Heart',
    children: [
        `<g clip-path="url(#a)">`,
        `<path d="m11.96 7.7-1.19-1.28a5.07 5.07 0 1 0-7.06 7.25l8.1 7.16c.1.1.27.1.38 0l8.1-7.16a5.07 5.07 0 1 0-7.06-7.25L12.04 7.7z" />`,
        `</g>`,
        `<defs>`,
        `<clipPath id="a">`,
        `<path d="M0 0h24v24H0z" />`,
        `</clipPath>`,
        `</defs>`,
    ]
};